import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import STATUS from './constants';
import { Title } from './elements';

const { COMPLETE, PROCESS, WAIT } = STATUS;

/**
 * Step
 *
 * This component is in charge of displaying
 * a step
 *
 * @param {string} className // Classes needed by styled component.
 * @param {any} children // Any component or dom element.
 * @param {number} stepNumber // The step number.
 * @param {string} status // The actual status of a step (COMPLETE, PROCESS, WAIT).
 *
 * @return {jsx}
 */
const Step = ({ stepNumber, status, url, children, className }) => (
  <li className={className}>
    {status === COMPLETE ? (
      <Link to={url}>
        <Title status={status}>
          {stepNumber}.{children}
        </Title>
      </Link>
    ) : (
      <Title status={status}>
        {stepNumber}.{children}
      </Title>
    )}
  </li>
);

/**
 * PropTypes Validation
 */
const { oneOf, string } = PropTypes;
Step.propTypes = {
  className: string,
  children: PropTypes.any,
  stepNumber: string,
  status: oneOf([COMPLETE, PROCESS, WAIT]),
  url: string.isRequired,
};

/**
 * Default Props
 */
Step.defaultProps = {
  className: '',
  children: null,
  stepNumber: '1',
  status: PROCESS,
};

export default styled(Step)`
  /* For small devices */
  ${breakpoint('xs', 'md')`
    padding: 1.2rem;
    border-top: 1px solid;
    color: ${({ theme: { palette } }) => palette.lightGrey};
    text-align: center;
    
    &:first-of-type {
      border-top: none;
    }
`};
`;



// WEBPACK FOOTER //
// ./src/components/Steps/Step.js